import ReportInvoicingList from './report-invoicing.list';

export default {
  list: ReportInvoicingList,
};
